export default __webpack_public_path__ + "static/media/logoSeaside.d872e013.svg";